import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {FeatureFlagType} from '@toolify/server/src/models/mongoose/PlanModel/enum/FeatureFlagType'
import {PermissionType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionType'
import {i18n} from '@toolify/client/src/setup/i18n'
import {IMessageAction} from '@toolify/client/src/modules/notifications/types/IMessageAction'
import {useMessages} from '@toolify/client/src/modules/notifications/composables/useMessages'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {useCurrentWorkspacePlan} from '@toolify/client/src/composables/useCurrentWorkspacePlan'
import {
  getBillingLinkAction,
  getWorkspaceGroupsHref,
  getWorkspaceUpgradeHref,
} from '@toolify/client/src/modules/billing/helpers/getWorkspaceBillingBlockedMessage'

const messages = useMessages()

export const PLAN_FEATURE_NOT_IN_PLAN_COLLAPSE_KEY = 'plan.feature:notInPlan'
export const PLAN_FEATURE_SEAT_REQUIRED_COLLAPSE_KEY = 'plan.feature:seatRequired'

interface IPlanFeatureNotEntitledMessage {
  text: string
  action: IMessageAction | null
  collapseKey: string
}

function getSeatRequiredMessage(workspaceName: string | undefined): IPlanFeatureNotEntitledMessage {
  if (!useWorkspaceStore().hasPermission(PermissionType.manageWorkspacePaymentMethods)) {
    return {
      text: i18n.global.t('errors.planFeatureSeatRequired'),
      action: null,
      collapseKey: PLAN_FEATURE_SEAT_REQUIRED_COLLAPSE_KEY,
    }
  }
  return {
    text: i18n.global.t('errors.planFeatureSeatRequiredForAdmin'),
    action: getBillingLinkAction(
      workspaceName ? getWorkspaceGroupsHref(workspaceName) : null,
      i18n.global.t('billing.seatRequired.assignSeatsCta'),
    ),
    collapseKey: PLAN_FEATURE_SEAT_REQUIRED_COLLAPSE_KEY,
  }
}

function getNotInPlanMessage(workspaceName: string | undefined): IPlanFeatureNotEntitledMessage {
  return {
    text: i18n.global.t('errors.planFeatureNotInPlan'),
    action: getBillingLinkAction(
      workspaceName ? getWorkspaceUpgradeHref(workspaceName) : null,
      i18n.global.t('workspaceUpgrade.upgradePlan'),
    ),
    collapseKey: PLAN_FEATURE_NOT_IN_PLAN_COLLAPSE_KEY,
  }
}

export function showPlanFeatureNotEntitledToast(apiException: ApiException): void {
  const featureFlagType = (apiException.extra as {featureFlagType?: FeatureFlagType} | undefined)?.featureFlagType
  const workspaceName = useWorkspaceStore().currentWorkspace?.name
  const isSeatRequired = Boolean(featureFlagType) && useCurrentWorkspacePlan().hasFeatureFlag(featureFlagType)
  const {text, action, collapseKey} = isSeatRequired
    ? getSeatRequiredMessage(workspaceName)
    : getNotInPlanMessage(workspaceName)
  if (!action) {
    messages.error(text, {collapseKey})
    return
  }
  messages.error(text, {
    duration: 0,
    pinned: true,
    actions: [action],
    collapseKey,
  })
}
